<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <div class="mb-3 text-right">
        <a-button type="primary" :loading="saving" icon="save" @click="handleSave">
          Save Entry
        </a-button>
      </div>
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="school_class" slot-scope="school_class">
          <div>{{ school_class.name }}</div>
        </template>
        <template slot="section" slot-scope="section">
          <div>{{ section.name }}</div>
        </template>
        <template slot="exam" slot-scope="exam">
          <div>
            <div class="font-weight-bold">{{exam.name}}</div>
          </div>
        </template>
        <template slot="is_all_section" slot-scope="is_all_section">
          <div>
            <a-tag color="green" v-if="is_all_section === 1">Yes</a-tag>
            <a-tag color="red" v-else>No</a-tag>
          </div>
        </template>
        <template slot="start_date" slot-scope="start_date">
          <div class="font-weight-bold">{{moment(start_date).format('DD-MM-YYYY')}}</div>
        </template>
        <template slot="end_date" slot-scope="end_date">
          <div class="font-weight-bold">{{moment(end_date).format('DD-MM-YYYY')}}</div>
        </template>
        <template slot="declared" slot-scope="declared">
          <div>
            <a-tag color="green" v-if="declared === 1">Declared</a-tag>
            <a-tag color="red" v-else>Not Declared</a-tag>
          </div>
        </template>
        <span slot="markEntryTitle">
          <a-checkbox :checked="allMarkEntry" @change="toggleAll('mark_entry_open', $event)"> Mark Entry</a-checkbox>
        </span>

        <span slot="remarkEntryTitle">
          <a-checkbox :checked="allRemarkEntry" @change="toggleAll('remark_entry_open', $event)"> Remark Entry</a-checkbox>
        </span>

        <template slot="mark_entry_open" slot-scope="text, record">
          <a-checkbox v-model="record.mark_entry_open" />
        </template>

        <template slot="remark_entry_open" slot-scope="text, record">
          <a-checkbox v-model="record.remark_entry_open" />
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Manage -->
            <a href="javascript:;" :class="['btn btn-sm btn-success btn-with-addon mr-2']"
              @click="handleAdmitcardClick(record)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe fe-square']" />
              </span>
              A/C
            </a>
            <!-- Manage -->
            <a href="javascript:;" :class="['btn btn-sm btn-primary mr-2']"
              @click="handleManageClick(record)"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${record.declared ? 'fe-eye' : 'fe-settings'}`]" />
              </span>
              <!-- {{ record.declared ? 'View' : 'Manage' }} -->
            </a>
            <!-- Edit -->
            <a href="javascript:;" :class="[`${record.declared ? 'disabled' : ''}`, 'btn btn-sm btn-light mr-2']"
              @click="showEditModal(record)"
              :disabled="record.declared ? true : false"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
            </a>
            <!-- Delete -->
            <a href="javascript:;" :class="[`${record.declared ? 'disabled' : ''}`, 'btn btn-sm btn-danger']"
              @click="onDelete(record)"
              :disabled="record.declared ? true : false"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <!-- Edit Form -->
    <edit-exam-setup ref="editClassExamSetup" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'

import EditExamSetup from '@/components/exam/setup/Forms/Edit/index'

const columns = [
  {
    title: 'Class',
    dataIndex: 'school_class',
    scopedSlots: { customRender: 'school_class' },
    sorter: (a, b) => a.school_class.name.localeCompare(b.school_class.name),
    width: 100,
  },
  {
    title: 'Section',
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' },
    sorter: (a, b) => a.section.name.localeCompare(b.section.name),
    width: 100, // Explicit width for section
  },
  {
    title: 'School Exams',
    dataIndex: 'exam',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'exam' },
    sorter: (a, b) => a.exam.name.localeCompare(b.exam.name),
    width: 200,
  },
  {
    title: 'Same for all sections',
    dataIndex: 'is_all_section',
    scopedSlots: { customRender: 'is_all_section' },
    width: 150,
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    scopedSlots: { customRender: 'start_date' },
    width: 120,
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    scopedSlots: { customRender: 'end_date' },
    width: 120,
  },
  {
    title: 'Declared',
    dataIndex: 'declared',
    scopedSlots: { customRender: 'declared' },
    width: 120,
  },
  // ADD WIDTHS TO THESE TWO
  {
    dataIndex: 'mark_entry_open',
    slots: { title: 'markEntryTitle' },
    scopedSlots: { customRender: 'mark_entry_open' },
    width: 120, // Enough for "Mark Entry" + checkbox
    align: 'center',
  },
  {
    dataIndex: 'remark_entry_open',
    slots: { title: 'remarkEntryTitle' },
    scopedSlots: { customRender: 'remark_entry_open' },
    width: 140, // Enough for "Remark Entry" + checkbox
    align: 'center',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
    width: 220, // INCREASE THIS: You have 4 buttons, they need ~220px
    fixed: 'right', // Optional: keeps actions visible while scrolling
  },
]

export default {

  name: 'ExamSetupTable',
  components: {
    EditExamSetup,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
    allMarkEntry() {
      return this.data.length > 0 && this.data.every(item => item.mark_entry_open)
    },
    allRemarkEntry() {
      return this.data.length > 0 && this.data.every(item => item.remark_entry_open)
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editClassExamSetup.showModal(record.id)
      this.$eventBus.$emit('openExamSetupEditModal', record.id)
    },
    handleManageClick: function (record) {
      this.$router.push({ name: 'exammanage', params: { id: record.id } })
    },
    handleAdmitcardClick: function (record) {
      this.$router.push({ name: 'examadmitcard', params: { id: record.id } })
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    toggleAll(field, e) {
      const checked = e.target.checked
      this.data.forEach(item => {
        // Use Vue.set if these fields weren't originally in the API response
        this.$set(item, field, checked)
      })
    },
    handleSave() {
      this.saving = true
      const payload = {
        exams: this.data.map(item => ({
          id: item.id,
          mark_entry_open: item.mark_entry_open ? 1 : 0,
          remark_entry_open: item.remark_entry_open ? 1 : 0,
        })),
      }
      console.log('Final Payload:', payload)

      this.$http.post('/api/classsectionexam/save-entry-control', payload)
        .then(() => {
          this.$notification.success({ message: 'Success', description: 'Updated successfully.' })
        })
        .catch(err => {
          // Ensure saving flag is cleared and error is reported
          this.saving = false
          this.$notification.error({
            message: 'Error',
            description: err && err.message ? err.message : 'Failed to update.',
          })
        })
        .finally(() => {
          this.saving = false
        })
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this school exam!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/classsectionexam/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Successfully deleted class section exam setup.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
